import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';

class UserGroupGuard extends React.Component {
  render() {
    const {group, type, children} = this.props;

    if (!group) {
      return null;
    }

    const match = (Array.isArray(type) && type.find(t => group === t)) || type === group;

    return (
      <div>
        {match && children}
      </div>
    );
  }
}

UserGroupGuard.propTypes = {
  children: propTypes.node,
  type: propTypes.oneOfType([propTypes.arrayOf(propTypes.string), propTypes.string]),
};

const mapStateToProps = state => ({
  group: state.viewConfig.profile.attributes['user-group'],
});

export default connect(mapStateToProps)(UserGroupGuard);



// WEBPACK FOOTER //
// ./src/components/common/guards/user-group.jsx